import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import {
  PRE_MODERATION_ALL,
  PRE_MODERATION_ASSIGNED,
  PRE_MODERATION_BY_ID,
  PRE_MODERATION_CHANGE_STATUS,
  PRE_MODERATION_HISTORY_CREATE,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const preModerationAssigned = createAsyncThunk(
  PRE_MODERATION_ASSIGNED,
  async (params: PayloadCreatorParams<`${typeof API.PRE_MODERATION_ASSIGNED}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.preModerationAssigned(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const preModerationAll = createAsyncThunk(
  PRE_MODERATION_ALL,
  async (params: PayloadCreatorParams<`${typeof API.PRE_MODERATION_ALL}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.preModerationAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const preModerationById = createAsyncThunk(
  PRE_MODERATION_BY_ID,
  async (params: PayloadCreatorParams<`${typeof API.PRE_MODERATION}{id}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.preModerationById(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const preModerationHistoryCreate = createAsyncThunk(
  PRE_MODERATION_HISTORY_CREATE,
  async (params: PayloadCreatorParams<`${typeof API.PRE_MODERATION_HISTORY_CREATE}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.preModerationHistoryCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)
export const preModerationChangeStatus = createAsyncThunk(
  PRE_MODERATION_CHANGE_STATUS,
  async (params: PayloadCreatorParams<`${typeof API.PRE_MODERATION_CHANGE_STATUS}`, 'put'>, { rejectWithValue }) => {
    try {
      const response = await api.preModerationChangeStatus(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const preModerationAllClear = createAction(`${PRE_MODERATION_ALL}/clear`)
export const preModerationAssignedClear = createAction(`${PRE_MODERATION_ASSIGNED}/clear`)
export const preModerationByIdClear = createAction(`${PRE_MODERATION_BY_ID}/clear`)
